<template>
  <span
    class="calico-meter"
    :style="style"
  />
</template>

<script>
export default {
    name: "CalicoMeter",
    props: {
        percentage: {
            type: Number,
            default: 100
        },
        color: {
            type: String,
            default: ""
        }
    },
    computed: {
        style() {
            return {
                backgroundImage: `conic-gradient(
                  ${this.color} ${this.percentage * 3.6}deg, 
                  transparent 0deg
                )`,
            }
        }
    }
};
</script>

<style lang="scss">
.calico-meter {
    position: absolute;
    border-radius: 100%;
    height: 100%;
    width: 100%;
    mask: radial-gradient(farthest-side, transparent calc(100% - 10px), black 0);
}
</style>